<template>
  <div>
    <headline>
      Benutzerzugängliche Räume
    </headline>
    <portal to="modal" v-if="showPopup">
      <modal @close="showPopup = false">
        <template slot="header"> Schreibtische</template>
        <tailwind-table :header="['Name', 'Details', 'Fester User']" class="mt-4">
          <tr v-for="(desk, i) in room.desks" :class="{'bg-gray-50': i % 2}">
            <td class="p-2">
              <a :href="`/admin/desks/${desk.id}`">
                {{ desk.name }}
              </a>
            </td>
            <td class="p-2">
              {{ desk.details }}
            </td>
            <td class="p-2">
                            <span v-if="desk.user">
                                {{ desk.user.name }}, {{desk.user.first_name}}
                            </span>
              <span v-show="!desk.user">
                                -
                            </span>
            </td>
          </tr>
        </tailwind-table>
      </modal>
    </portal>
    <tailwind-table :header="['Raum', 'Anzahl Schreibtische', 'Fest', 'Frei', 'Personenbegrenzung', 'Schreibtische anzeigen']">
      <tr v-for="room in rooms" :key="room.id">
        <td class="px-6 py-2">{{ room.name }}</td>
        <td class="px-6 py-2">{{ room.desks.length }}</td>
        <td class="px-6 py-2">{{ room.desks.filter(desk => desk.user_id !== null).length }}</td>
        <td class="px-6 py-2">{{ room.desks.filter(desk => desk.user_id === null).length }}</td>
        <td class="px-6 py-2">{{ room.limit_persons }}</td>
        <td class="px-6 py-2">
          <button-white @click="desks(room)"><i class="fa fa-desktop"></i>
          </button-white>
        </td>
      </tr>
    </tailwind-table>

  </div>
</template>

<script>

import TailwindTable from "../UI/TailwindTable.vue";
import Headline from "../UI/Headline.vue";
import ButtonSecondary from "../UI/ButtonSecondary.vue";
import ButtonWhite from "../UI/ButtonWhite.vue";
import Modal from "../Modal.vue";

export default {
  name: "UserAccessibleRooms",
  props: ['rooms'],
  components: { Modal, ButtonWhite, Headline, TailwindTable},
  data: () => ({
    showPopup: false,
    room: null
  }),

  mounted() {
  },

  methods: {
    desks(room) {
      this.room = room;
      this.showPopup= true;
    }
  }
}
</script>

<style scoped>

</style>
